import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { PageTitle } from '~/components/common';
import { DeliveryAgencyDeliveryStatusRealtime } from '~/components/delivery-agency/status/DeliveryAgencyDeliveryStatusRealtime';
import { DeliveryAgencyDeliveryStatusTrend } from '~/components/delivery-agency/status/DeliveryAgencyDeliveryStatusTrend';
import { RefreshTimer } from '~/components/delivery-agency/status/RefreshTimer';
import { PageWrapper } from '~/components/layout';

import { deliveryAgencyKeys } from '~/hooks/delivery-agency/queries';

import { BREAD_CRUMB, PATH } from '~/constants';

import styles from './DeliveryAgencyStatusPage.module.scss';

const DeliveryAgencyStatusPage = () => {
  const queryClient = useQueryClient();

  const refresh = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: deliveryAgencyKeys.all });
  }, [queryClient]);

  return (
    <PageWrapper>
      <PageTitle
        title="배송 현황"
        breadcrumbs={BREAD_CRUMB[PATH.DELIVERY_AGENCY_STATUS]}
        hasFilter={false}
        titleExtra={<RefreshTimer onRefresh={refresh} />}
      />
      <div className={styles.container}>
        <div className={styles['section-realtime']}>
          <DeliveryAgencyDeliveryStatusRealtime />
        </div>
        <div className={styles['section-status-trend']}>
          <DeliveryAgencyDeliveryStatusTrend />
        </div>
      </div>
    </PageWrapper>
  );
};

export default DeliveryAgencyStatusPage;
